/* KEY STUDIO — maquette 3D interactive d'un bien (page /pages/visite/<handle> et démonstration de la page
   « Maquette 3D interactive »). Balisage : snippets/keystudio-visite-corps.liquid. Demande three.js r128
   (keystudio-three-r128.min.js) et keystudio-meubles3d.js. Lancer avec window.kvDemarrer().
   Source : refonte/visite/keystudio-visite.js. */
window.kvDemarrer = () => {
  const BIEN = JSON.parse(document.getElementById("kv-donnees").textContent || "{}");
  const IMAGES = JSON.parse(document.getElementById("kv-photos").textContent || "[]");
  // Chaque pièce photographiée appelle sa photo par son rang dans le champ « photos ».
  // « photos » : [rang, rang…] donne plusieurs photos à une pièce ; la première est celle de « photo ».
  BIEN.pieces = (BIEN.pieces || []).map((p) => {
    const rangs = (Array.isArray(p.photos) ? p.photos : [p.photo]).filter((r) => typeof r === "number" && IMAGES[r]);
    if (!rangs.length) return { ...p, photo: null, galerie: [] };
    const galerie = rangs.map((r, n) => {
      const im = IMAGES[r];
      return { src: im.src, grand: im.grand, alt: im.alt || p.titre || p.nom, titre: n === 0 ? (p.titre || p.nom) : (im.alt || p.titre || p.nom), detail: n === 0 ? (p.detail || "") : "", cadre: n === 0 ? (p.cadre || "50% 50%") : "50% 50%" };
    });
    return { ...p, photo: galerie[0], galerie };
  });
  const $ = (s) => document.querySelector(s);
  const reduit = matchMedia("(prefers-reduced-motion: reduce)").matches;
  const photos = BIEN.pieces.map((p, i) => ({ ...p, i })).filter((p) => p.photo);
  const n2 = (k) => String(k + 1).padStart(2, "0");
  const court = (nom) => nom.replace(/^(Le|La|Les|L') ?/i, "").replace(/^./, (c) => c.toUpperCase());

  const autres = BIEN.pieces.filter((p) => !p.photo).map((p) => p.nom.toLowerCase());
  if (autres.length) { $("#kv-aussi").textContent = "Aussi sur le plan : " + autres.join(", ") + "."; $("#kv-aussi").hidden = false; }

  // ------------------------------------------------------------------ panneau
  const liste = $("#kv-pieces");
  liste.innerHTML = photos.map((p, k) => `<li><button type="button" data-k="${k}" aria-current="${k === 0}"><span class="n">${n2(k)}</span><strong>${court(p.nom)}</strong><small>${p.surface ? p.surface : p.galerie.length + (p.galerie.length > 1 ? " photos" : " photo")}</small></button></li>`).join("");
  let choisie = 0, vue = 0;
  const vignettes = $("#kv-vignettes");
  function montrerPhoto(k, n = 0) {
    const p = photos[k];
    if (!p) return;
    vue = Math.min(n, p.galerie.length - 1);
    const ph = p.galerie[vue];
    const img = $("#kv-photo");
    img.src = ph.src; img.alt = ph.alt; img.style.objectPosition = ph.cadre;
    $("#kv-photo-piece").textContent = `${n2(k)} · ${p.nom}` + (p.galerie.length > 1 ? ` · ${vue + 1}/${p.galerie.length}` : "");
    $("#kv-photo-titre").textContent = ph.titre;
    $("#kv-photo-detail").textContent = [ph.detail, vue === 0 ? p.surface : ""].filter(Boolean).join(" · ");
    if (vignettes) {
      vignettes.hidden = p.galerie.length < 2;
      vignettes.innerHTML = p.galerie.length < 2 ? "" : p.galerie.map((g, m) => `<button type="button" data-n="${m}" aria-current="${m === vue}" aria-label="Photo ${m + 1} sur ${p.galerie.length}"><img src="${g.src.replace(/width=\d+/, "width=240")}" alt="" loading="lazy"></button>`).join("");
    }
    liste.querySelectorAll("button").forEach((b) => b.setAttribute("aria-current", String(+b.dataset.k === k)));
  }

  // ------------------------------------------------------------------ maquette
  const canvas = $("#kv-maquette");
  let maquette = null;
  try { maquette = window.THREE && (BIEN.murs || []).length ? creer() : null; } catch (e) { maquette = null; }
  if (!maquette) { $("#kv-sans3d").hidden = false; canvas.hidden = true; $(".kv-commandes").hidden = true; $("#kv-aide").hidden = true; }

  function creer() {
    const renderer = new THREE.WebGLRenderer({ canvas, antialias: true, alpha: true });
    const mobile = matchMedia("(max-width: 899px)").matches;
    renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, mobile ? 2 : 1.75));
    renderer.outputEncoding = THREE.sRGBEncoding;
    renderer.shadowMap.enabled = true;
    renderer.shadowMap.type = THREE.PCFSoftShadowMap;
    const scene = new THREE.Scene();
    const camera = new THREE.PerspectiveCamera(28, 1, 0.3, 400);
    const S = 0.01, HM = BIEN.hauteur || 2.5;
    const [CX, CZ] = BIEN.centre;
    const P = (x, y) => [(x - CX) * S, (y - CZ) * S];
    const lin = (hex) => new THREE.Color(hex).convertSRGBToLinear();
    const mat = (c, o = {}) => new THREE.MeshStandardMaterial({ color: lin(c), roughness: 0.9, metalness: 0, ...o });
    const M = {
      mur: mat(0xfbfaf6), coupe: mat(0x2b2c29, { roughness: 0.75 }), sol: mat(0xdcd2bf), dalle: mat(0xc9bea9),
      meuble: mat(0xc8bca6), estrade: mat(0xd2c7b2),
      vitre: new THREE.MeshStandardMaterial({ color: lin(0xbfd3d9), roughness: 0.1, transparent: true, opacity: 0.4, depthWrite: false }),
    };
    const murPlein = [M.mur, M.mur, M.coupe, M.mur, M.mur, M.mur];
    const appart = new THREE.Group(), murs = new THREE.Group(), meubles = new THREE.Group();
    appart.add(murs, meubles); scene.add(appart);
    function bloc(parent, x, y, w, d, y0, y1, m, ombre = true) {
      const mesh = new THREE.Mesh(new THREE.BoxGeometry(w * S, y1 - y0, d * S), m);
      const [px, pz] = P(x + w / 2, y + d / 2);
      mesh.position.set(px, (y0 + y1) / 2, pz);
      mesh.castShadow = ombre; mesh.receiveShadow = true;
      parent.add(mesh);
      return mesh;
    }
    function mur(sens, fixe, de, a, ep, ouvertures) {
      const rect = (u0, u1) => (sens === "h" ? [u0, fixe - ep / 2, u1 - u0, ep] : [fixe - ep / 2, u0, ep, u1 - u0]);
      let u = de - ep / 2;
      for (const [o0, o1, type] of ouvertures || []) {
        if (o0 > u) bloc(murs, ...rect(u, o0), 0, HM, murPlein);
        if (type === "fenetre") {
          bloc(murs, ...rect(o0, o1), 0, 0.95, M.mur);
          bloc(murs, ...rect(o0, o1), 2.15, HM, M.mur);
          const [x, y, w, d] = rect(o0, o1);
          const vt = sens === "h" ? [x, y + ep * 0.4, w, ep * 0.2] : [x + ep * 0.4, y, ep * 0.2, d];
          bloc(murs, ...vt, 0.95, 2.15, M.vitre, false).receiveShadow = false;
        } else if (type === "baie") {
          const [x, y, w, d] = rect(o0, o1);
          const vt = sens === "h" ? [x, y + ep * 0.4, w, ep * 0.2] : [x + ep * 0.4, y, ep * 0.2, d];
          bloc(murs, ...vt, 0.02, 2.15, M.vitre, false).receiveShadow = false;
          bloc(murs, ...rect(o0, o1), 2.15, HM, M.mur);
        } else {
          bloc(murs, ...rect(o0, o1), 2.1, HM, M.mur);
        }
        u = o1;
      }
      if (a + ep / 2 > u) bloc(murs, ...rect(u, a + ep / 2), 0, HM, murPlein);
    }
    BIEN.murs.forEach((m) => mur(...m));
    if (BIEN.dalle) { const [dx, dy, dw, dd] = BIEN.dalle; bloc(appart, dx, dy, dw, dd, -0.12, 0, [M.dalle, M.dalle, M.sol, M.dalle, M.dalle, M.dalle], false); }
    (BIEN.estrades || []).forEach(([x, y, w, d, h]) => bloc(meubles, x, y, w, d, 0, h, M.estrade));
    // Ameublement modélisé (meubles3d.js) : murs coupés à COUPE en vue 3D, décor mural à part.
    const COUPE = 1.3, deco = new THREE.Group();
    appart.add(deco);
    let habille = null;
    if (BIEN.ameublement && window.KSMeubles) {
      try { habille = KSMeubles.habiller({ THREE, appart, murs, meubles, BIEN, P, S, HM, renderer, scene, mobile, coupe: COUPE, deco }); } catch (e) { habille = null; }
    }
    if (habille) M.estrade.color = lin(0x8a6a4a);
    else (BIEN.meubles || []).forEach(([x, y, w, d, h, b = 0]) => bloc(meubles, x, y, w, d, b, b + h, M.meuble));
    const voiles = BIEN.pieces.map((p, i) => {
      if (!p.photo) return null;
      const [x, y, w, d] = p.zone;
      const m = new THREE.Mesh(new THREE.PlaneGeometry(w * S, d * S), new THREE.MeshBasicMaterial({ color: 0xaa8022, transparent: true, opacity: 0, depthWrite: false }));
      m.rotation.x = -Math.PI / 2;
      const [px, pz] = P(x + w / 2, y + d / 2);
      m.position.set(px, (p.sol || 0.004) + 0.002, pz);
      m.userData.k = photos.findIndex((q) => q.i === i);
      appart.add(m);
      return m;
    }).filter(Boolean);
    if (BIEN.entree) {
      const or = new THREE.MeshBasicMaterial({ color: 0xaa8022, side: THREE.DoubleSide });
      const repere = new THREE.Group();
      [new THREE.Mesh(new THREE.RingGeometry(0.15, 0.19, 48), or), new THREE.Mesh(new THREE.CircleGeometry(0.075, 32), or)].forEach((m) => { m.rotation.x = -Math.PI / 2; repere.add(m); });
      const [rx, rz] = P(...BIEN.entree);
      repere.position.set(rx, -0.105, rz);
      appart.add(repere);
    }
    const table = new THREE.Mesh(new THREE.PlaneGeometry(90, 90), new THREE.ShadowMaterial({ opacity: 0.16 }));
    table.rotation.x = -Math.PI / 2; table.position.y = -0.121; table.receiveShadow = true;
    scene.add(table);
    scene.add(new THREE.HemisphereLight(0xffffff, lin(0xc9bfac), 0.66));
    const soleil = new THREE.DirectionalLight(0xfff1dc, 1.3);
    soleil.position.set(-7, 13, 6); soleil.castShadow = true;
    soleil.shadow.mapSize.set(mobile ? 1024 : 2048, mobile ? 1024 : 2048);
    Object.assign(soleil.shadow.camera, { left: -12, right: 12, top: 12, bottom: -12, near: 1, far: 50 });
    soleil.shadow.bias = -0.0004; soleil.shadow.normalBias = 0.02;
    scene.add(soleil);
    const contre = new THREE.DirectionalLight(0xe9eef4, 0.32);
    contre.position.set(8, 6, -7); scene.add(contre);
    const calque = $("#kv-labs");
    const labs = BIEN.pieces.map((p, i) => {
      const el = document.createElement("span");
      const k = photos.findIndex((q) => q.i === i);
      el.className = "kv-lab" + (p.photo ? "" : " muette");
      el.innerHTML = p.photo ? `<b>${n2(k)}</b>${court(p.nom)}` : (p.court || p.nom);
      calque.appendChild(el);
      const [x, y, w, d] = p.zone;
      return { el, x: x + w / 2, y: y + d / 2, h: p.sol || 0.004, k };
    });
    return { renderer, scene, camera, appart, murs, meubles, voiles, labs, P, habille, deco, coupe: COUPE / HM };
  }

  if (maquette) {
    const { renderer, scene, camera, appart, murs, meubles, voiles, labs, P, habille, deco, coupe } = maquette;
    const VUE3D = { theta: -0.55, phi: 50, dist: 1, tx: 0, tz: 0, mur: 1 };
    const cam = { ...VUE3D }, but = { ...VUE3D };
    let mode = "3d", W = 0, H = 0, sale = true, survol = -1, derniereAction = performance.now(), guidee = null, saisie = null;
    const v3 = new THREE.Vector3();
    function taille() {
      const w = canvas.clientWidth, h = canvas.clientHeight;
      if (w === W && h === H) return;
      W = w; H = h;
      renderer.setSize(W, H, false);
      camera.aspect = W / H;
      camera.updateProjectionMatrix();
      sale = true;
    }
    function baseD() {
      const vf = THREE.MathUtils.degToRad(camera.fov);
      const hf = 2 * Math.atan(Math.tan(vf / 2) * camera.aspect);
      return ((BIEN.rayon || 6) / Math.sin(Math.min(vf, hf) / 2)) * (W < 600 ? 1.0 : 1.08);
    }
    function poser() {
      const phi = THREE.MathUtils.degToRad(cam.phi), d = baseD() * cam.dist;
      camera.position.set(cam.tx + d * Math.cos(phi) * Math.sin(cam.theta), d * Math.sin(phi), cam.tz + d * Math.cos(phi) * Math.cos(cam.theta));
      camera.lookAt(cam.tx, 0.25 * (1 - cam.dist / 1.6), cam.tz);
      const hm = Math.max(0.02, cam.mur);
      murs.scale.y = hm * (habille ? coupe : 1); meubles.scale.y = deco.scale.y = hm;
    }
    function etiquettes() {
      appart.updateMatrixWorld(); camera.updateMatrixWorld();
      labs.forEach((l) => {
        const [px, pz] = P(l.x, l.y);
        v3.set(px, l.h + 0.05, pz).project(camera);
        const x = ((v3.x + 1) / 2) * W, y = ((1 - v3.y) / 2) * H;
        l.el.style.transform = `translate(${x.toFixed(1)}px, ${y.toFixed(1)}px) translate(-50%, -50%)`;
        l.el.style.opacity = v3.z < 1 && x > -40 && x < W + 40 && y > -20 && y < H + 20 ? "1" : "0";
        l.el.classList.toggle("actif", l.k === choisie && l.k >= 0);
      });
    }
    function voilesMaj() { voiles.forEach((vo) => { vo.material.opacity = vo.userData.k === choisie ? 0.22 : vo.userData.k === survol ? 0.12 : 0; }); sale = true; }
    function boucle(t) {
      taille();
      if (!reduit && mode === "3d" && !guidee && !saisie && t - derniereAction > 6000 && but.dist >= 0.95) but.theta += 0.0011;
      let bouge = false;
      const k = reduit ? 1 : 0.12;
      for (const c in cam) { const d = but[c] - cam[c]; if (Math.abs(d) > 1e-4) { cam[c] += d * k; bouge = true; } else cam[c] = but[c]; }
      if ((bouge || sale) && W && H) { poser(); rendre(); etiquettes(); sale = false; }
      requestAnimationFrame(boucle);
    }
    // Comparaison : la moitié gauche montre un jeu de meubles, la droite l'autre, même caméra.
    let comparer = null;
    function rendre() {
      if (!comparer || !habille) { renderer.render(scene, camera); return; }
      const g = Math.round(W * comparer.pos);
      renderer.setScissorTest(true);
      habille.choisir(comparer.g); renderer.setScissor(0, 0, g, H); renderer.setViewport(0, 0, W, H); renderer.render(scene, camera);
      habille.choisir(comparer.d); renderer.setScissor(g, 0, W - g, H); renderer.render(scene, camera);
      renderer.setScissorTest(false); renderer.setScissor(0, 0, W, H);
    }
    const centrePiece = (k) => { const [x, y, w, d] = BIEN.pieces[photos[k].i].zone; return P(x + w / 2, y + d / 2); };
    function viser(k) {
      const [tx, tz] = centrePiece(k);
      Object.assign(but, { tx, tz, dist: mode === "plan" ? 0.72 : 0.68, phi: mode === "plan" ? 89.4 : Math.max(50, Math.min(64, but.phi)) });
    }
    function ensemble() { Object.assign(but, { tx: 0, tz: 0, dist: 1 }); if (mode === "plan") Object.assign(but, { phi: 89.4, theta: 0 }); }
    function passer(m) {
      mode = m;
      document.querySelectorAll("[data-vue]").forEach((b) => b.setAttribute("aria-pressed", String(b.dataset.vue === m)));
      if (m === "plan") Object.assign(but, { phi: 89.4, theta: Math.round(but.theta / (Math.PI / 2)) * (Math.PI / 2), mur: 0.06 });
      else Object.assign(but, { phi: 50, mur: 1 });
      derniereAction = performance.now();
    }
    if (habille && habille.noms.length) {
      const zone = $("#kv-jeux"), note = $("#kv-virtuel"), pied = $("#kv-mention-virtuel");
      const A = BIEN.ameublement.jeux;
      const deux = habille.noms.length === 2;
      zone.innerHTML = habille.noms.map((n) => `<button type="button" data-jeu="${n}" aria-pressed="${n === habille.courant()}">${A[n].court || A[n].nom || n}</button>`).join("")
        + (deux ? `<button type="button" data-jeu="=" aria-pressed="false">Comparer</button>` : "");
      const voileC = $("#kv-comparer");
      const poserC = () => { voileC.style.setProperty("--pos", (comparer.pos * 100).toFixed(2) + "%"); sale = true; };
      zone.hidden = false;
      const mentions = habille.noms.filter((n) => A[n].virtuel && A[n].mention).map((n) => A[n].mention);
      if (mentions.length) { pied.textContent = mentions[0]; pied.hidden = false; }
      const jeu = (n) => {
        if (n === "=" && deux) {
          const [g, d] = habille.noms;
          comparer = { g, d, pos: 0.5 };
          $("#kv-comparer-g").textContent = A[g].court || A[g].nom || g; $("#kv-comparer-d").textContent = A[d].court || A[d].nom || d;
          voileC.hidden = false; poserC();
          zone.querySelectorAll("button").forEach((b) => b.setAttribute("aria-pressed", String(b.dataset.jeu === "=")));
          const virt = habille.noms.find((m) => A[m].virtuel);
          note.textContent = virt ? (A[virt].badge || "Aménagement virtuel · non contractuel") : ""; note.hidden = !virt;
          derniereAction = performance.now(); return;
        }
        comparer = null; voileC.hidden = true;
        habille.choisir(n);
        zone.querySelectorAll("button").forEach((b) => b.setAttribute("aria-pressed", String(b.dataset.jeu === n)));
        note.textContent = A[n].virtuel ? (A[n].badge || "Aménagement virtuel · non contractuel") : "";
        note.hidden = !A[n].virtuel;
        sale = true; derniereAction = performance.now();
      };
      zone.addEventListener("click", (e) => { const b = e.target.closest("[data-jeu]"); if (b) jeu(b.dataset.jeu); });
      const poignee = $("#kv-comparer-poignee");
      let tire = null;
      poignee.addEventListener("pointerdown", (e) => { e.preventDefault(); e.stopPropagation(); tire = e.pointerId; poignee.setPointerCapture(e.pointerId); derniereAction = performance.now(); });
      poignee.addEventListener("pointermove", (e) => {
        if (tire !== e.pointerId || !comparer) return;
        const r = canvas.getBoundingClientRect();
        comparer.pos = Math.max(0.04, Math.min(0.96, (e.clientX - r.left) / r.width)); poserC(); derniereAction = performance.now();
      });
      ["pointerup", "pointercancel"].forEach((t) => poignee.addEventListener(t, () => { tire = null; }));
      poignee.addEventListener("keydown", (e) => {
        if (!comparer || !["ArrowLeft", "ArrowRight"].includes(e.key)) return;
        e.preventDefault(); comparer.pos = Math.max(0.04, Math.min(0.96, comparer.pos + (e.key === "ArrowLeft" ? -0.05 : 0.05))); poserC();
      });
      jeu(habille.courant());
    }
    window.__kvChoisir = (k, viserAussi) => { choisie = k; montrerPhoto(k); voilesMaj(); if (viserAussi) viser(k); derniereAction = performance.now(); };
    const rayon = new THREE.Raycaster(), ndc = new THREE.Vector2();
    function pieceSous(cx, cy) {
      const r = canvas.getBoundingClientRect();
      ndc.set(((cx - r.left) / r.width) * 2 - 1, -((cy - r.top) / r.height) * 2 + 1);
      rayon.setFromCamera(ndc, camera);
      const t = rayon.intersectObjects(voiles)[0];
      return t ? t.object.userData.k : -1;
    }
    canvas.addEventListener("pointerdown", (e) => { saisie = { x: e.clientX, y: e.clientY, theta: but.theta, phi: but.phi, bouge: false, id: e.pointerId }; derniereAction = performance.now(); arreterGuidee(); });
    canvas.addEventListener("pointermove", (e) => {
      if (saisie && e.pointerId === saisie.id) {
        const dx = e.clientX - saisie.x, dy = e.clientY - saisie.y;
        if (!saisie.bouge && Math.hypot(dx, dy) > 6) { saisie.bouge = true; canvas.setPointerCapture(e.pointerId); canvas.classList.add("saisie"); $("#kv-aide").style.opacity = "0"; }
        if (saisie.bouge) {
          but.theta = saisie.theta - dx * 0.0085;
          if (e.pointerType === "mouse" && mode === "3d") but.phi = Math.max(16, Math.min(89.4, saisie.phi + dy * 0.22));
          derniereAction = performance.now();
        }
        return;
      }
      if (e.pointerType !== "mouse") return;
      const k = pieceSous(e.clientX, e.clientY);
      if (k !== survol) { survol = k; voilesMaj(); canvas.classList.toggle("sur-piece", k >= 0); }
    });
    const lacher = (e) => {
      if (!saisie || e.pointerId !== saisie.id) return;
      if (!saisie.bouge && e.type === "pointerup") { const k = pieceSous(e.clientX, e.clientY); if (k >= 0) window.__kvChoisir(k, true); }
      saisie = null; canvas.classList.remove("saisie");
    };
    canvas.addEventListener("pointerup", lacher);
    canvas.addEventListener("pointercancel", lacher);
    canvas.addEventListener("pointerleave", () => { if (survol !== -1) { survol = -1; voilesMaj(); canvas.classList.remove("sur-piece"); } });
    canvas.addEventListener("wheel", (e) => { e.preventDefault(); but.dist = Math.max(0.3, Math.min(1.6, but.dist * Math.exp(e.deltaY * 0.0012))); derniereAction = performance.now(); }, { passive: false });
    document.querySelectorAll("[data-zoom]").forEach((b) => b.addEventListener("click", () => { but.dist = Math.max(0.3, Math.min(1.6, but.dist * (b.dataset.zoom === "in" ? 0.78 : 1.28))); derniereAction = performance.now(); }));
    $("#kv-ensemble").addEventListener("click", () => { arreterGuidee(); ensemble(); derniereAction = performance.now(); });
    document.querySelectorAll("[data-vue]").forEach((b) => b.addEventListener("click", () => passer(b.dataset.vue)));
    addEventListener("resize", () => { sale = true; });
    function arreterGuidee() { if (!guidee) return; clearInterval(guidee); guidee = null; $("#kv-guidee").setAttribute("aria-pressed", "false"); $("#kv-guidee").textContent = "Visite guidée"; }
    $("#kv-guidee").addEventListener("click", () => {
      if (guidee) { arreterGuidee(); ensemble(); return; }
      $("#kv-guidee").setAttribute("aria-pressed", "true"); $("#kv-guidee").textContent = "Arrêter la visite";
      window.__kvChoisir(0, true);
      guidee = setInterval(() => { const k = choisie + 1; if (k >= photos.length) { arreterGuidee(); ensemble(); return; } window.__kvChoisir(k, true); }, 4500);
    });
    window.__kvArreter = arreterGuidee;
    requestAnimationFrame(boucle);
  } else {
    $("#kv-guidee").hidden = true;
  }

  const choisir = (k, viser) => { if (window.__kvChoisir) window.__kvChoisir(k, viser); else { choisie = k; montrerPhoto(k); } };
  const arreter = () => { if (window.__kvArreter) window.__kvArreter(); };
  liste.addEventListener("click", (e) => { const b = e.target.closest("[data-k]"); if (b) { arreter(); choisir(+b.dataset.k, true); } });
  $("#kv-prec").addEventListener("click", () => { arreter(); choisir((choisie - 1 + photos.length) % photos.length, true); });
  $("#kv-suiv").addEventListener("click", () => { arreter(); choisir((choisie + 1) % photos.length, true); });
  const grand = $("#kv-grand");
  $("#kv-agrandir").addEventListener("click", () => {
    const p = photos[choisie];
    if (!p) return;
    const ph = p.galerie[vue] || p.photo;
    $("#kv-grand-img").src = ph.grand || ph.src; $("#kv-grand-img").alt = ph.alt;
    $("#kv-grand-legende").textContent = `${n2(choisie)} · ${p.nom} · ${ph.titre}`;
    try { grand.showModal(); } catch (_) { grand.setAttribute("open", ""); }
  });
  if (vignettes) vignettes.addEventListener("click", (e) => { const b = e.target.closest("[data-n]"); if (b) { arreter(); montrerPhoto(choisie, +b.dataset.n); } });
  $("#kv-grand-fermer").addEventListener("click", () => grand.close());
  grand.addEventListener("click", (e) => { if (e.target === grand) grand.close(); });
  montrerPhoto(0);
  if (window.__kvChoisir) window.__kvChoisir(0, false);
};
